/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Validation_Contract_Coverage_DuplicateInputs */

const en_clients_validation_contract_coverage_duplicate = /** @type {(inputs: Clients_Validation_Contract_Coverage_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each case type can only be added once.`)
};

const pt_br2_clients_validation_contract_coverage_duplicate = /** @type {(inputs: Clients_Validation_Contract_Coverage_DuplicateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada tipo de caso pode ser adicionado apenas uma vez.`)
};

/**
* | output |
* | --- |
* | "Each case type can only be added once." |
*
* @param {Clients_Validation_Contract_Coverage_DuplicateInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_validation_contract_coverage_duplicate = /** @type {((inputs?: Clients_Validation_Contract_Coverage_DuplicateInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Validation_Contract_Coverage_DuplicateInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_validation_contract_coverage_duplicate(inputs)
	return pt_br2_clients_validation_contract_coverage_duplicate(inputs)
});